import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';
import { StagnantRevenueChart } from '../components/StagnantRevenueChart';

export const Home = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-[#F5F5F5]">
      {/* Hero Section */}
      <section className="container mx-auto px-6 py-20 max-w-6xl">
        <div className="space-y-6">
          <p className="text-[#E85D04] uppercase tracking-widest text-sm font-semibold">
            Revenue Plateau Specialist
          </p>
          <h1 className="text-6xl md:text-7xl font-bold leading-tight">
            Bryan Adham Chew
          </h1>
          <p className="text-[#E85D04] text-3xl md:text-4xl italic" style={{ fontFamily: 'Georgia, serif' }}>
            Brands hire me when paid spend is climbing but revenue has stalled. I diagnose where the acquisition system is breaking and rebuild the conversion loop.
          </p>
          <p className="text-lg leading-relaxed max-w-3xl text-[#F5F5F5]">
            6+ years experience across high-CAC, high-friction markets where acquisition efficiency depends on tight conversion systems, creative iteration speed, and funnel clarity.
          </p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
          <Card className="bg-[#1a1a1a] border-none p-6 space-y-2 transition-transform hover:scale-105">
            <div className="text-4xl font-bold text-[#E85D04] break-words">30x</div>
            <div className="text-[#888888] text-sm leading-tight">Peak ROAS</div>
          </Card>
          <Card className="bg-[#1a1a1a] border-none p-6 space-y-2 transition-transform hover:scale-105">
            <div className="text-4xl font-bold text-[#E85D04] break-words">5→17%</div>
            <div className="text-[#888888] text-sm leading-tight">Peak PDP CVR lift</div>
          </Card>
          <Card className="bg-[#1a1a1a] border-none p-6 space-y-2 transition-transform hover:scale-105">
            <div className="text-4xl font-bold text-[#E85D04] break-words">100%</div>
            <div className="text-[#888888] text-sm leading-tight">Peak monthly revenue growth</div>
          </Card>
          <Card className="bg-[#1a1a1a] border-none p-6 space-y-2 transition-transform hover:scale-105">
            <div className="text-4xl font-bold text-[#E85D04] break-words">60%</div>
            <div className="text-[#888888] text-sm leading-tight">Peak blended CAC reduction</div>
          </Card>
        </div>
      </section>

      {/* Stagnant Revenue Chart */}
      <section className="container mx-auto px-6 py-20 max-w-6xl">
        <StagnantRevenueChart />
      </section>

      {/* The Problem I Solve */}
      <section className="container mx-auto px-6 py-20 max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card className="bg-[#1a1a1a] border-none border-l-4 border-l-[#E85D04] p-6 space-y-3 transition-transform hover:translate-x-1">
            <h3 className="text-xl font-semibold text-[#F5F5F5]">Ad spend up, revenue flat</h3>
            <p className="text-[#888888]">
              More traffic isn't the fix. The funnel is leaking between click and checkout.
            </p>
          </Card>
          <Card className="bg-[#1a1a1a] border-none border-l-4 border-l-[#E85D04] p-6 space-y-3 transition-transform hover:translate-x-1">
            <h3 className="text-xl font-semibold text-[#F5F5F5]">Mobile CVR gap</h3>
            <p className="text-[#888888]">
              65% of traffic is mobile. Conversion is half of desktop. That's a structural problem, not a creative one.
            </p>
          </Card>
          <Card className="bg-[#1a1a1a] border-none border-l-4 border-l-[#E85D04] p-6 space-y-3 transition-transform hover:translate-x-1">
            <h3 className="text-xl font-semibold text-[#F5F5F5]">Checkout abandonment</h3>
            <p className="text-[#888888]">
              Users adding to cart but not completing. Usually shipping costs, trust signals, or friction at payment.
            </p>
          </Card>
          <Card className="bg-[#1a1a1a] border-none border-l-4 border-l-[#E85D04] p-6 space-y-3 transition-transform hover:translate-x-1">
            <h3 className="text-xl font-semibold text-[#F5F5F5]">Pricing page confusion</h3>
            <p className="text-[#888888]">
              Too many options, no clear hierarchy. Users spend 45 seconds and leave without clicking buy.
            </p>
          </Card>
        </div>
      </section>

      {/* CTA Section */}
      <section className="container mx-auto px-6 py-20 max-w-6xl">
        <div className="text-center">
          <Link to="/how-i-work">
            <Button className="bg-[#E85D04] hover:bg-[#E85D04]/90 text-white px-8 py-6 text-lg font-semibold transition-colors group">
              See how I work
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};